module.exports = __webpack_public_path__ + "static/media/react_logo.7bdceb15.jpg";